import Vue from "vue"
import App from "./App.vue"
import ApolloClient from "apollo-boost"
import VueApollo from "vue-apollo"

Vue.use(VueApollo)

const apolloClient = new ApolloClient({
  uri: "https://api.graph.cool/simple/v1/ck42kb5lx73zy01412qa4b0el"
})
Vue.config.productionTip = false

const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})

new Vue({
  apolloProvider,
  render: h => h(App)
}).$mount("#app")
